import Size from "../../../../viewmodel/core/base/Size";
import TextAndLinkCalculation from "./TextAndLinkCalculation";

const { default: BaseMindElementDataCalculation } = require("./BaseMindElementDataCalculation");

/**
 * ProjectName: MindMap
 * Created by tony on 2020/7/14
 * Copyright(c) 2020 mindyushu.com
 */
class TextAndMoreAndTaskCalculation extends TextAndLinkCalculation {
    constructor(data, nodeLayoutType) {
        super(data, nodeLayoutType)
    }

    calculate() {
        if (this.data.moreContent == null || this.data.taskContent == null) {
            return;
        }
        let textMindElementContent = this.getTextMindElementContent();
        let moreContent = this.data.moreContent;
        if (textMindElementContent == null) {
            return;
        }
        
        let textRext = this.caluleTextCGRect();

        let textHeight = textRext.height();
        moreContent.width = textHeight;
        moreContent.height = textHeight;
        let size = this.includeMoreAndTextAndTaskSize();
        let moreAndTextSize = this.includeMoreAndTextSize();
        let iconsSize = new Size(moreContent.width, moreContent.height);
        let textEdgeInsets = this.getTextEdgeInsets();

        let marginPoint = this.getMargin(size);
        let marginX = marginPoint.left;
        let marginY = marginPoint.top;

        let iconLeft = 0;
        let iconTop = 0;

        iconLeft = (moreAndTextSize.getWidth() - iconsSize.getWidth() - this.iconMargin);
        iconTop = (moreAndTextSize.getHeight() - iconsSize.getHeight()) / 2;
        textMindElementContent.x = marginX;
        textMindElementContent.y = ((moreAndTextSize.getHeight()) - textMindElementContent.height) / 2 + marginY;

        moreContent.x = iconLeft + marginX;
        moreContent.y = iconTop + marginY;

        this.data.taskContent.x = marginX + textEdgeInsets.left;
        this.data.taskContent.y = textMindElementContent.y + textMindElementContent.height;
        this.data.taskContent.width = this.taskOriginalSize.getWidth();
        this.data.taskContent.height = this.taskOriginalSize.getHeight();

        this.setMindElementSize(size.getWidth(), size.getHeight(), marginPoint);

    }
}
export default TextAndMoreAndTaskCalculation
